export const ZOHO_FORM_IDS = {
  PARTNERS: 'AccurityPartners/formperma/3HVLkEPV0s-H_WCfZF6OkfuedjFKIVEN6y9Rp2FiK4k',
  CONTACT: 'AccurityContactForm/formperma/BERv0lXt4QAAl0AAoyc0GWmUB-lT_g4FhmfpBKoeHHQ',
  WHITEPAPER: 'AccurityWhitepaper/formperma/ahgndm3NthvAjVNOJR-2_eYfnhEPrAcwajC0kZJmMR8',
  DEMO_SIGNUP: 'AccurityDemoSignUp/formperma/IFO_SZebPqne-x-Pt6tss0l7KETKLBLznakB4gI8Nnc'
};